import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsIceSkateNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g
        clipPath="url(#sports_ice_skate_normal_large_svg__clip0_138_163)"
        fill=""
      >
        <path d="M5.25 4L2.03 19.73A53.818 53.818 0 001 30.18 6.828 6.828 0 007.82 37h33.24A4.953 4.953 0 0046 32.05v-3.33a4.853 4.853 0 00-3.21-4.55l-5.77-2.07-12.75-6.84-2.09-12.27A3.578 3.578 0 0018.64 0h-2.18a3.02 3.02 0 00-2.87 2.07L11.28 9H6.27l1.02-5H5.25zm14.27 7l-.34-2h-5.79l2.1-6.3a1.02 1.02 0 01.97-.7h2.18a1.589 1.589 0 011.57 1.33l2.09 12.28-2.78 5.17 1.76.95 2.42-4.51 3 1.61-2.43 4.51 1.76.94 2.43-4.5 2.99 1.61-2.42 4.5 1.77.95 2.42-4.51 2.92 1.57.08.03-2.43 4.52 1.76.95 2.57-4.79 4 1.44A2.86 2.86 0 0144 28.72v3.33A2.947 2.947 0 0141.06 35H7.82A4.829 4.829 0 013 30.18a52.4 52.4 0 01.41-6.5L20.78 33H25L3.73 21.57c.08-.48.17-.97.27-1.45L5.86 11h13.66zM28 42h-9a3.01 3.01 0 01-3-3h-2a5 5 0 005 5h9a5 5 0 005-5h-2a3.01 3.01 0 01-3 3z" />
        <path d="M5.12 48h37.93a3.952 3.952 0 003.06-6.45L44.04 39h-2.59l3.11 3.82A1.947 1.947 0 0143.05 46H5.12a2.121 2.121 0 01-1.81-3.23L5.61 39H3.26L1.6 41.73A4.127 4.127 0 005.12 48z" />
      </g>
      <defs>
        <clipPath id="sports_ice_skate_normal_large_svg__clip0_138_163">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsIceSkateNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsIceSkateNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsIceSkateNormalLarge;
